<div *ngIf="rentIncomeAvailable" class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="margin-top: 60px; page-break-inside: avoid;">
    <div class="row">
        <div class="col-sm-12 text-center font-weight-bold">
            Schedule-2
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-center font-weight-bold">
          (Particulars of Income from Rent)
        </div>
    </div>
    <div class="row my-5">
        <div class="col-sm-5">Name of the Taxpayer: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            TIN:
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item }}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>
    <div class="row mt-5 mb-5">
        <div class="col-sm-12">
            <div class="row bt bb">
                <div class="col-sm-3 text-center bl br pt-1 pb-2">Location, description and ownership proportion of property</div>
                <div class="col-sm-9">
                    <div class="row h-100">
                        <div class="col-sm-6 text-center br pt-1 pb-2">Total Rental Income Computation</div>
                        <div class="col-sm-3 text-center br pt-1 pb-2">Amount (Taka)</div>
                        <div class="col-sm-3 text-center br pt-1 pb-2">Amount (Taka)</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 bl br bb pt-1 pb-2">
                    <div class="mb-1" *ngFor="let value of returnData?.headSummery?.rentDetailsSummery?.propertyDetails">{{value}}</div>
                </div>
                <div class="col-sm-9 rent-income-table">
                    <div class="row">
                        <div class="col-sm-6 bb br">1. Rent Received or Annual Value (whichever is higher)</div>
                        <div class="col-sm-3 bb br">{{greaterOfRentAndAnnual | currencySeparatorBD }}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">2. Advance Rent Received</div>
                        <div class="col-sm-3 bb br">{{advanceRentReceived | currencySeparatorBD }}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">3. Value of any Benefit in addition to 1 & 2</div>
                        <div class="col-sm-3 bb br">{{valueOfAnyBenefit | currencySeparatorBD }}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">4. Adjusted Advance Rent</div>
                        <!-- <div class="col-sm-3 bb br">{{data?.advanceAdjustmentAmount | currencySeparatorBD }}</div> -->
                        <div class="col-sm-3 bb br">{{advanceAdjustmentAmount | currencySeparatorBD }}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">5. Vacancy Allowance</div>
                        <div class="col-sm-3 bb br">{{data?.vacancyAllowanceAmount | currencySeparatorBD }}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9 bb br">6. Total Rental Value</div>
                        <div class="col-sm-3 bb br">{{totalRentValue | currencySeparatorBD }}</div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9 bb br">7. Allowable Deduction</div>
                        <div class="col-sm-3 br">
                            {{
                                (data?.repairCollection + data?.municipalLocalTaxOrLandRevenue
                                 + data?.interestOnLoanMortgageCapital
                                 + data?.insurancePremium + data?.other) | currencySeparatorBD
                            }}
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-6 bb br">(a) Repair, Collection etc.</div>
                        <div class="col-sm-3 bb br">{{data?.repairCollection | currencySeparatorBD }}</div>
                        <div class="col-sm-3 br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">(b) Municipal or Local Tax</div>
                        <div class="col-sm-3 bb br">{{data?.municipalLocalTaxOrLandRevenue | currencySeparatorBD }}</div>
                        <div class="col-sm-3 br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">(c) Land Revenue</div>
                        <div class="col-sm-3 bb br"></div>
                        <div class="col-sm-3 br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">(d) Interest Paid on Loan / Mortgage / Capital Charge</div>
                        <div class="col-sm-3 bb br">{{data?.interestOnLoanMortgageCapital | currencySeparatorBD }}</div>
                        <div class="col-sm-3 br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">(e) Insurance Premium Paid</div>
                        <div class="col-sm-3 bb br">{{data?.insurancePremium | currencySeparatorBD }}</div>
                        <div class="col-sm-3 br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 bb br">(f) Others, if any</div>
                        <div class="col-sm-3 bb br">{{ otherIncome | currencySeparatorBD }}</div>
                        <div class="col-sm-3 br bb"></div>
                    </div>

                    <div class="row">
                        <div class="col-sm-9 bb br">8. Total Admissible Deduction</div>
                        <div class="col-sm-3 bb br">{{data?.allowableDeduction | currencySeparatorBD }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9 bb br">9. Net Income (6 – 8)</div>
                        <div class="col-sm-3 bb br">{{ netIncomeFromRent | currencySeparatorBD }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9 bb br">10. Taxpayer’s Share, if applicable</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9 bb br">11. Special Rental Income</div>
                        <div class="col-sm-3 bb br">{{data?.specialRentalIncome | currencySeparatorBD }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9 bb br">12. Total Rental Income (9 + 11)</div>
                        <div class="col-sm-3 bb br">{{totalRentalIncome | currencySeparatorBD }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- specialRentalIncome -->